<template>
	<div class="container" v-if="isAdmin">
		<div class="row justify-content-center">
			<div class="col-md-12">
				<div class="bg-info text-white" style>
					<div class="card-header">
						<h5 class="margin-bottom-0">Περίοδος: {{ titleOfPeriod }}</h5>
					</div>
					<div>
						<div class="form-group">
							<select v-model="periodid_selected" class="form-control" @change="onPeriodChange($event)">
								<option v-for="period in periods" v-bind:value="period.id" v-bind:key="period.title">{{ period.id }}. {{ period.title }}</option>
							</select>
						</div>
					</div>

					<div class="form-inline bg-info">
						<div class="mx-auto col-sm-3">Άλλαξε τον τίτλο της Περιόδου:</div>
						<input type="text" class="form-control m-1 mx-auto col-sm-3" v-model="titleOfPeriod" placeholder="period" />

						<button type="submit" class="btn btn-light m-1 mx-auto col-sm-2" v-on:click="changeTitleOfSchedulePeriod()">Ανανέωση Τίτλου</button>
						<button type="submit" class="btn btn-light m-1 mx-auto col-sm-2" v-on:click="addNewPeriodToSchedule()">Προσθήκη Περιόδου</button>
						<button type="submit" class="btn btn-light m-1 mx-auto col-sm-1" v-on:click="createAndDownloadPdf()">Pdf</button>
					</div>
				</div>
				<br />

				<div class="card">
					<div class="card-header">
						<h5 class="margin-bottom-0">Διπλωματικές για Προσθήκη στην Περίοδο: {{ titleOfPeriod }}</h5>
					</div>

					<table class="table table-striped table-bordered table-responsive border-0 mb-0">
						<thead>
							<tr>
								<th width="05%" class="border-top-0 border-left-0 text-center px-2">Κωδικός</th>
								<th width="60%" class="border-top-0">Τίτλος</th>

								<th width="10%" class="border-top-0 text-center">Εξεταστές</th>
								<th width="10%" class="border-top-0 text-center">Φοιτητές</th>
								<th width="10%" class="border-top-0 text-center">Είδος</th>

								<th width="05%" class="border-top-0 border-right-0 text-center">Ενέργεια</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="(result, index) in thesesOff" v-bind:key="index">
								<th scope="row">
									<router-link v-bind:to="{ name: 'thesis_view', params: { id: result.id } }" v-html="result.code"></router-link>
								</th>
								<td v-html="result.title"></td>
								<td v-html="result.teachersnames"></td>
								<td v-html="result.studentsnames"></td>
								<td v-html="typeOfThesisTextMin(result.typeofthesis)"></td>
								<td class="border-bottom-0 border-right-0 text-center">
									<button class="btn btn-outline-success btn-block addtoschedule" v-on:click="addthesistoscheduleperiod(result.id)">
										<small>Προσθήκη στην τρέχουσα Περίοδο</small>
									</button>
									<a v-if="result.teacher1 == null || result.teacher2 == null || result.teacher3 == null" v-bind:href="'/thesis/' + result.id + '/add_teachers'">Προσθήκη Εξεταστή</a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<br />

				<div class="card">
					<div class="card-header">
						<h5 class="margin-bottom-0">Πρόγραμμα για την Περίοδο: {{ titleOfPeriod }}</h5>
					</div>

					<table class="table table-striped table-bordered table-responsive border-0 mb-0">
						<thead>
							<tr>
								<th width="02%" class="border-top-0 border-left-0 text-center">A/A</th>
								<th width="02%" class="border-top-0 border-left-0 text-center">Κωδικός</th>
								<th width="40%" class="border-top-0">Τίτλος</th>

								<th width="10%" class="border-top-0 text-center">Μέρα</th>
								<th width="05%" class="border-top-0 text-center">Ώρα</th>

								<th width="10%" class="border-top-0 text-center">Εξεταστές</th>
								<th width="10%" class="border-top-0 text-center">Φοιτητές</th>

								<th width="5%" class="border-top-0 text-center">Περίοδος</th>
								<th width="5%" class="border-top-0 text-center">Είδος</th>
								<th width="05%" class="border-top-0 border-right-0 text-center">Ενέργεια</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="(result, index) in thesesOn" v-bind:key="index">
								<th scope="row" v-html="index + 1"></th>
								<th scope="row">
									<router-link v-bind:to="{ name: 'thesis_view', params: { id: result.id } }" v-html="result.code"></router-link>
								</th>
								<td v-html="result.title"></td>
								<!-- https://www.npmjs.com/package/vue2-datepicker#value-type -->
								<!-- https://mengxiong10.github.io/vue2-datepicker/index.html#Basic -->
								<td>
									<date-picker
										value-type="YYYY-MM-DD"
										v-model="result.day"
										format="DD-MM-YYYY"
										:editable="false"
										:clearable="false"
										style="width:140px;"
										:disabled="result.status == settings.thesis.status.pending_for_exam_and_grading+100"
									></date-picker>
								</td>
								<td>
									<date-picker
										value-type="H:mm:ss"
										v-model="result.time"
										format="HH:mm"
										:minute-step="5"
										type="time"
										:editable="false"
										:clearable="false"
										style="width:100px;"
										:disabled="result.status == settings.thesis.status.pending_for_exam_and_grading+100"
									></date-picker>
								</td>
								<td v-html="result.teachersnames"></td>
								<td v-html="result.studentsnames"></td>
								<td v-html="result.period"></td>
								<td v-html="typeOfThesisTextMin(result.typeofthesis)"></td>
								<td class="border-bottom-0 border-right-0 text-center">
									<button :disabled="result.status == settings.thesis.status.pending_for_exam_and_grading+100" class="btn btn-primary" v-on:click="updateschedule(result.sid, result.time, result.day)">Ανανέωση</button>
									<button :disabled="result.status == settings.thesis.status.pending_for_exam_and_grading" class="btn btn-outline-danger btn-block mt-2 removefromschedule" v-on:click="removefromschedule(result.sid)">
										Αφαίρεση
									</button>
									<!-- <a v-if="((result.teacher1 == null) || (result.teacher2 == null) || (result.teacher3 == null)) && (result.status != settings.thesis.status.pending_for_exam_and_grading)" v-bind:href="'/thesis/'+ result.id + '/add_teachers'">Τροποποίηση Εξεταστή</a> -->
									<a  v-bind:href="'/thesis/' + result.id + '/add_teachers'">Τροποποίηση Εξεταστών</a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<br />
				<br />
				<button class="btn btn-outline-danger btn-block mt-2 removefromschedule" v-on:click="finalizeScheduleOfPeriod(periodid_selected)">Οριστικοποίηση Προγράμματος για αυτήν τη περίοδο</button>
				<div class="text-break">
					
					<br />Ο κάθε Επιβλέπων είναι υποχρεωμένος και μπορεί να μπεί στο Σύστημα και να βαθμολογήσει για όλους τους εξεταστές της Διπλωματικής. 
					<br />
					<br />Συνοπτικά: Με το πάτημα του κουμπιού Οριστικοποίηση 					
					<br />Ελέγχει αν έχουν μπει τρεις εξεταστές σε κάθε Διπλωματική της Περιόδου. <br />Η Διπλωματική αυτή αλλάζει κατάσταση από approved_and_waiting_to_present(4) σε pending_for_exam_and_grading(5). <br />Δεν μπορεί να γίνει καμία
					αλλαγή σε Ημερομηνία/Ώρα και εξεταστές. <br />Σημειώνεται, επίσημα, ως ημερομηνία παρουσίασης (presentation_date) για την κάθε διπλωματική η ημερομηνία που αναγράφει στην περίοδο. 
					<br /><strong>Μόνο με την οριστικοποίηση κάθε επιβλέπων μπορεί να μπεί στο σύστημα και να βαθμολογήσει και για τους άλλους δύο εξεταστές. </strong>
					<br />Μόλις ολοκληρωθεί η βαθμολόγηση τότε αυτόματα η Διπλωματική αυτή αλλάζει κατάσταση από pending_for_exam_and_grading(5) σε completed(6).
					<br />
					<br />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Mixin from "@/helpers/mixin";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/el";

import moment from "moment";
moment.locale("el");

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
	name: "Schedule",
	components: {
		DatePicker
	},
	mixins: [Mixin],
	data() {
		return {
			thesesOff: [],
			thesesOn: [],
			periods: [],
			periodid_selected: 1,
			titleOfPeriod: ""
		};
	},
	watch: {
		$route(to, from) {
			console.log(to);
			console.log(from);
		}
	},
	methods: {
		getData() {
			const _this = this;
			this.$store
				.dispatch("http_get_schedules", {
					period: _this.periodid_selected
				})
				.then(resp => {
					console.log("getData");
					_this.thesesOff = typeof resp.thesesOff !== "undefined" ? resp.thesesOff : [];
					_this.thesesOn = typeof resp.thesesOn !== "undefined" ? resp.thesesOn : [];
				})
				.catch(e => {
					console.error(e);
				});
		},
		updateschedule: function(sid, time, day) {
			const _this = this;
			this.$store
				.dispatch("http_update_schedule", {
					scheduleId: sid,
					timepickerSchedule: time,
					datepickerSchedule: day,
					period: _this.periodid_selected
				})
				.then(resp => {
					_this.thesesOff = typeof resp.thesesOff !== "undefined" ? resp.thesesOff : [];
					_this.thesesOn = typeof resp.thesesOn !== "undefined" ? resp.thesesOn : [];
					_this.periodid_selected = resp.period;
				})
				.catch(e => {
					console.error(e);
				});
		},
		addthesistoscheduleperiod: function(id) {
			const _this = this;
			this.$store
				.dispatch("http_add_thesis_to_schedule_period", {
					thesisid: id,
					period: _this.periodid_selected
				})
				.then(resp => {
					_this.thesesOff = typeof resp.thesesOff !== "undefined" ? resp.thesesOff : [];
					_this.thesesOn = typeof resp.thesesOn !== "undefined" ? resp.thesesOn : [];
					_this.periodid_selected = resp.period;
				})
				.catch(e => {
					alert(e.bodyText);
					console.error(e);
				});
		},
		finalizeScheduleOfPeriod: function(periodId) {
			var r = confirm(this.Translate("@_ARE_YOU_SURE"));
			if (r !== true) {
				return;
			}

			const _this = this;
			this.$store
				.dispatch("http_finalize_schedule_of_period", {
					period: periodId
				})
				.then(resp => {
					_this.thesesOff = typeof resp.thesesOff !== "undefined" ? resp.thesesOff : [];
					_this.thesesOn = typeof resp.thesesOn !== "undefined" ? resp.thesesOn : [];
					_this.periodid_selected = resp.period;
				})
				.catch(e => {
					alert(e.bodyText);
					console.error(e);
				});
		},
		removefromschedule: function(sid) {
			const _this = this;
			this.$store
				.dispatch("http_remove_from_schedule", {
					scheduleid: sid,
					period: _this.periodid_selected
				})
				.then(resp => {
					_this.thesesOff = typeof resp.thesesOff !== "undefined" ? resp.thesesOff : [];
					_this.thesesOn = typeof resp.thesesOn !== "undefined" ? resp.thesesOn : [];
				})
				.catch(e => {
					console.error(e);
				});
		},
		getPeriods() {
			const _this = this;
			this.$store
				.dispatch("http_get_schedule_periods")
				.then(resp => {
					_this.periods = typeof resp !== "undefined" ? resp : [];
					_this.periodid_selected = _this.periods.length;
					_this.titleOfPeriod = this.periods[_this.periodid_selected - 1].title;
					_this.getData();
				})
				.catch(e => {
					console.error(e);
				});
		},
		onPeriodChange(event) {
			//console.log(event.target.value);
			const _this = this;
			this.$store
				.dispatch("http_get_schedules", {
					period: event.target.value
				})
				.then(resp => {
					_this.titleOfPeriod = this.periods[_this.periodid_selected - 1].title;
					_this.thesesOff = typeof resp.thesesOff !== "undefined" ? resp.thesesOff : [];
					_this.thesesOn = typeof resp.thesesOn !== "undefined" ? resp.thesesOn : [];
				})
				.catch(e => {
					console.error(e);
				});
		},
		changeTitleOfSchedulePeriod() {
			const _this = this;
			this.$store
				.dispatch("http_change_title_of_schedule_period", {
					period: _this.periodid_selected,
					title: _this.titleOfPeriod
				})
				.then(resp => {
					_this.periodid_selected = resp.period;
					_this.periods[_this.periodid_selected - 1].title = resp.title;
				})
				.catch(e => {
					console.error(e);
				});
		},
		addNewPeriodToSchedule() {
			const _this = this;
			this.$store
				.dispatch("http_add_new_period_to_schedule")
				.then(() => {
					_this.getPeriods();
				})
				.catch(e => {
					console.error(e);
				});
		},
		createAndDownloadPdf() {
			var pinax = new Array(this.thesesOn.length);
			pinax[0] = new Array(6);
			pinax[0][0] = "A/A";
			pinax[0][1] = "ΚΩΔΙΚΟΣ";
			pinax[0][2] = "ΤΙΤΛΟΣ";
			pinax[0][3] = "ΗΜΕΡΑ";
			pinax[0][4] = "ΩΡΑ";
			pinax[0][5] = "ΕΞΕΤΑΣΤΙΚΗ ΕΠΙΤΡΟΠΗ";
			pinax[0][6] = "ΦΟΙΤΗΤΕΣ";

			for (var i = 0; i < this.thesesOn.length; i++) {
				pinax[i + 1] = new Array(6);
				pinax[i + 1][0] = i + 1;
				pinax[i + 1][1] = this.thesesOn[i].code;
				pinax[i + 1][2] = this.thesesOn[i].title;
				pinax[i + 1][3] = moment(this.thesesOn[i].day).format("dddd, DD-MM-YYYY");
				pinax[i + 1][4] = moment(this.thesesOn[i].time, "HH:mm").format("HH:mm");
				pinax[i + 1][5] = this.thesesOn[i].teachersnames.replace(/,/g, "\n");
				pinax[i + 1][6] = this.thesesOn[i].studentsnames.replace(/,/g, "\n");
			}
			//console.log(this.thesesOn);
			//http://pdfmake.org/playground.html
			var docDefinition = {
				pageOrientation: "landscape",
				// eslint-disable-line no-unused-vars
				content: [
					{
						text: this.Translate("@_PDF_TITLE1")+", " + this.titleOfPeriod,
						style: "header"
					},
					{
						// text:
						// 	"Προσκαλείται το εκπαιδευτικό προσωπικό και οι φοιτητές του τμήματος Μηχανικών Πληροφορικής και Ηλεκτρονικών Συστημάτων, στην παρουσίαση των Διπλωματικών/Πτυχιακών εργασιών του τμήματος, η οποία θα πραγματοποιηθεί στο αμφιθέατρο Η του πρώην τμήματος Ηλεκτρονικών Μηχανικών, σύμφωνα με το παρακάτω πρόγραμμα ",
						text:
						this.Translate("@_PDF_TITLE2"),
							//"Προσκαλείται το εκπαιδευτικό προσωπικό και οι φοιτητές του τμήματος Μηχανικών Πληροφορικής και Ηλεκτρονικών Συστημάτων, στην παρουσίαση των Διπλωματικών/Πτυχιακών εργασιών του τμήματος, η οποία θα πραγματοποιηθεί μέσω Zoom, σύμφωνα με το παρακάτω πρόγραμμα ",
							//"Προσκαλείται το εκπαιδευτικό προσωπικό και οι φοιτητές του τμήματος Μηχανικών Πληροφορικής και Ηλεκτρονικών Συστημάτων, στην παρουσίαση των Διπλωματικών/Πτυχιακών εργασιών του τμήματος, σύμφωνα με το παρακάτω πρόγραμμα. Θα ακολουθηθεί πιστά το πρωτόκολλο Covid όπως εφαρμόστηκε στις εξετάσεις.",
						style: "subheader"
					},
					{
						style: "tableTheses",
						layout: "myTableLayout",
						table: {
							headerRows: 1,
							widths: [25, "auto", "*", "auto", "auto", "auto", "auto"],
							body: pinax
						}
					}
				],
				//https://pdfmake.github.io/docs/document-definition-object/styling/
				styles: {
					header: {
						fontSize: 14,
						alignment: "center",
						bold: true,
						margin: [0, 0, 0, 10]
					},
					subheader: {
						fontSize: 11,
						bold: false,
						margin: [0, 10, 0, 5]
					},
					tableTheses: {
						fontSize: 10,
						alignment: "center",
						margin: [0, 5, 0, 15]
					}
				}
			};

			pdfMake.tableLayouts = {
				myTableLayout: {
					bold: function(i) {
						if (i === 0) {
							return true;
						}
					},
					fillColor: function(i) {
						if (i === 0) {
							return "yellow";
						}
						if (i % 2 === 0) {
							return "#AAAAAA";
						}
					}
					// hLineWidth: function (i, node) {
					//   if (i === 0 || i === node.table.body.length) {
					//     return 0;
					//   }
					//   return (i === node.table.headerRows) ? 2 : 1;
					// },
					// vLineWidth: function () {
					//   return 0;
					// },
					// hLineColor: function (i) {
					//   return i === 1 ? 'black' : '#aaa';
					// },
					// paddingLeft: function (i) {
					//   return i === 0 ? 0 : 8;
					// },
					// paddingRight: function (i, node) {
					//   return (i === node.table.widths.length - 1) ? 0 : 8;
					// }
				}
			};
			//pdfMake.createPdf(docDefinition).download();
			pdfMake.createPdf(docDefinition).open({}, window);
		}
	},
	created() {
		if (this.isAdmin) this.getPeriods();
	}
};
</script>

<style scoped></style>
